import { put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { api } from "../../Config/ApiInterface";
import {
  addRoomReservationFailure,
  addRoomReservationSuccess,
  roomReservationFailure,
  roomReservationSuccess,
  exporRoomReservationSuccess,
  exportRoomReservationFailure,
  getByIdRoomReservationFailure,
  getByIdRoomReservationSuccess,
  patchRoomReservationFailure,
  patchRoomReservationSuccess,
  putRoomRessignFailure,
  putRoomRessignSuccess,
  getAllRoomReservationListSuccess,
  getAllRoomReservationListFailure,
  updateRoomBookiingDetailsSuccess,
  updateRoomBookiingDetailsFailure,
  getReservationListExportSuccess,
  getReservationListExportFailure,
  getAllBookingLogsListSuccess,
  getAllBookingLogsListFailure,
} from "../../Actions";
import { postRecordPaymentFailure, postRecordPaymentSuccess } from "../../Actions/RoomReservation/RoomReservationAction";

const getErrorMessage = (error, fallback) => {
  return error?.response?.data?.message || fallback;
};

const getSuccessMessage = (response, fallback) => {
  return response?.data?.message || fallback;
};
// GET Room Reservation API
function* roomReservationSaga(action) {
  try {
    const response = yield call(api.post, `/reservation/all-room-availability`);
    yield put(roomReservationSuccess(response));
    // toast.success(response.message);
    // toast.success(getSuccessMessage(response, "Room reservation updated successfully."));
  } catch (error) {
    const message = getErrorMessage(
      error,
      "Failed to update room reservation."
    );
    yield put(roomReservationFailure(message));
    // toast.error(message);
  }
}

// POST Reservation API
function* addRoomReservationSaga(action) {
  try {
    const { formDataToSend, navigate } = action.payload;
    const payment_method = formDataToSend.get("payment_method") || "cash";
    const payment_status = formDataToSend.get("payment_status");
    const response = yield call(
      api.post,
      `/reservation/create-room-booking`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

   if(parseInt(payment_status)){  
    yield call(
      api.post,
      `/reservation/record-payment`,
      {reservation_id:response?.data?.data?.id,
      amount:response?.data?.data?.total_amount,
      payment_method}
    );
  }
    yield put(addRoomReservationSuccess(response.data));
    toast.success(
      getSuccessMessage(response, "Room reservation updated successfully.")
    );
    if (navigate) navigate(-1);
  } catch (error) {
    const message = getErrorMessage(
      error,
      "Failed to update room reservation."
    );
    yield put(addRoomReservationFailure(message));
    toast.error(message);
  }
}

function* patchRoomReservationSaga(action) {
  try {
    const { reservation_id, body ,navigate} = action.payload;
    let type=body.type;
    const response = yield call(
      api.patch,
      `/reservation${type==='checkout' ?"/checkout":type==='checkin' ? "/update-status":"/update-reservation"}/${reservation_id}`,
      body
    );
    yield put(patchRoomReservationSuccess(response.data));
    toast.success(
      getSuccessMessage(response, "Room reservation updated successfully.")
    );
    if (navigate){ navigate('/reservation/booking-list') };
  } catch (error) {
    const message = getErrorMessage(
      error,
      "Failed to update room reservation."
    );
    yield put(patchRoomReservationFailure(message));
    toast.error(message);
  }
}
function* getByIdRoomReservationSaga(action) {
  try {
    const { reservation_id } = action.payload;
    const response = yield call(
      api.post,
      `/reservation/get-booking-details/${reservation_id}`
    );
    yield put(getByIdRoomReservationSuccess(response.data));
    // toast.success(getSuccessMessage(response, "Room reservation updated successfully."));
  } catch (error) {
    const message = getErrorMessage(
      error,
      "Failed to update room reservation."
    );
    yield put(getByIdRoomReservationFailure(message));
    // toast.error(message);
  }
}

function* putRoomReassignSaga(action) {
  try {
    const hotel_id=localStorage.getItem('hotel_id')
    const { id: reservation_id, data } = action.payload;
    const response = yield call(
      api.put,
      `/reservation/reassign-room/${reservation_id}?hotel_id=${hotel_id}`,
      data
    );
    yield put(putRoomRessignSuccess(response.data));
    toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(putRoomRessignFailure(message));
    toast.error(message);
  }
}

function* exportRoomReservationSaga(action) {
  try {
    const response = yield call(api.post, `/reservation/export-reservations`);
    yield put(exporRoomReservationSuccess(response));
    toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(exportRoomReservationFailure(message));
    toast.error(message);
  }
}

// Get All Reservation Details List
function* allRoomReservationListSaga(action) {
  try {
    const { 
      page, 
      limit, 
      sortBy, 
      sortOrder,
      guest_name,
      room_number,
      booking_id,
      booking_status,
      check_in_start_date,
      check_in_end_date
    } = action.payload;
    
    let hotel_id = localStorage.getItem("hotel_id");

    const params = new URLSearchParams({ page, limit, hotel_id });

    // Add filter parameters if they exist
    if (guest_name) params.append('guest_name', guest_name);
    if (room_number) params.append('room_number', room_number);
    if (booking_id) params.append('booking_id', booking_id);
    if (booking_status) params.append('booking_status', booking_status);
    if (check_in_start_date) params.append('check_in_start_date', check_in_start_date);
    if (check_in_end_date) params.append('check_in_end_date', check_in_end_date);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);

    console.log('API URL:', `/reservation/reservation-list?${params}`); // Debug log

    const response = yield call(
      api.post,
      `/reservation/reservation-list?${params}`
    );
    
    yield put(getAllRoomReservationListSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(getAllRoomReservationListFailure(message));
    // toast.error(message);
  }
}
// BOOKING LOGS SAGA
function* allBookingLogsListSaga(action) {
  try {
    const { page, limit, reservation_id } = action.payload;
    const params = new URLSearchParams({ page, limit });
    let reservationId = reservation_id;

    const response = yield call(
      api.post,
      `/reservation/${reservationId}/logs?${params}`
    );
    yield put(getAllBookingLogsListSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to get booking logs");
    yield put(getAllBookingLogsListFailure(message));
    // toast.error(message);
  }
}

function* allReservationListExportSaga(action) {
  try {
    const { format } = action.payload;
    const params = new URLSearchParams({ format });
    const response = yield call(
      api.post,
      `/reservation/export-reservations?${params}`
    );
    yield put(getReservationListExportSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to download csv");
    yield put(getReservationListExportFailure(message));
    // toast.error(message);
  }
}

// Update Room Booking By Id
function* updateRoomBookingByIdSaga(action) {
  try {
    const { id: reservation_id, data } = action.payload;
    const response = yield call(
      api.patch,
      `/reservation/update-reservation-details/${reservation_id}`,
      data
    );

    yield put(updateRoomBookiingDetailsSuccess(response));
    toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(updateRoomBookiingDetailsFailure(message));
    toast.error(message);
  }
}

function* postRecordPaymentSaga(action) {
  try {
    const { data } = action.payload;
    // const response = yield call(
    //   api.post,
    //   `/reservation/record-payment`,
    //   data
    // );
    // yield put(postRecordPaymentSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } 
  catch (error) {
    const message = getErrorMessage(error, "Failed to update payment record");
    yield put(postRecordPaymentFailure(message));
    // toast.error(message);
  }
}

export {
  roomReservationSaga,
  addRoomReservationSaga,
  patchRoomReservationSaga,
  putRoomReassignSaga,
  getByIdRoomReservationSaga,
  exportRoomReservationSaga,
  allRoomReservationListSaga,
  updateRoomBookingByIdSaga,
  allReservationListExportSaga,
  allBookingLogsListSaga,
  postRecordPaymentSaga,
};
